module.exports = __webpack_public_path__ + "static/helping-img-dafc7f3436b0d4f44d59e1b91cd1fddb.jpg";